import React from "react"
import KEYBlue from "../common/keylist-blue"

const SeoServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">
            Our SEO service is much more than driving traffic, as it includes multiple picks like:
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="SEO Consultation" />
            <KEYBlue text="Complete Website Analysis" />
            <KEYBlue text="Improve Site Conversion" />
            <KEYBlue text="Reputation Management" />
            <KEYBlue text="Amplify Brand Awareness" />
              
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Improve Website Ranking" />
            <KEYBlue text="Competitor Analysis" />
            <KEYBlue text="Offer High-Quality Traffic" />
            <KEYBlue text="Improve Page Performance" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SeoServices
